import React from 'react';

type PageTitleProps = {
  text: string;
  icon: React.ReactNode;
  iconBgColor?: string;
  iconColor?: string;
  textColor?: string;
  subtitle?: string;
  widthClass?: string;
};

const PageTitle: React.FC<PageTitleProps> = ({
  text,
  icon,
  iconBgColor = 'bg-gray-100',
  iconColor = 'text-black',
  textColor = 'text-gray-800',
  subtitle,
  widthClass = 'w-[320px]', // adjust as needed to match the screenshot
}) => {
  return (
    <div className={`flex items-start gap-3 mb-3 ${widthClass}`}>
      <div className={`w-12 h-12 flex items-center justify-center rounded-md ${iconBgColor}`}>
        <span className={`${iconColor} text-2xl`}>{icon}</span>
      </div>
      <div>
        <h1 className={`text-xl font-semibold ${textColor}`}>
          {text}
        </h1>
        {subtitle && (
          <p className="text-xs text-gray-500 mt-1">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageTitle;

